import { render, staticRenderFns } from "./Company_elections.vue?vue&type=template&id=5e6acc5b&scoped=true&lang=pug&"
import script from "./Company_elections.vue?vue&type=script&lang=coffee&"
export * from "./Company_elections.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6acc5b",
  null
  
)

export default component.exports